var _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPrivacyPolicy(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "privacy-policy_svg__a",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 271 235.04",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "privacy-policy_svg__b",
    x1: 84.48,
    y1: 168.35,
    x2: 85.15,
    y2: 169.24,
    gradientTransform: "translate(-4287.73 8769.9) scale(51.52 -51.52)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3a3eef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#12b9d9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "privacy-policy_svg__c",
    x1: 84.57,
    y1: 177.81,
    x2: 85.62,
    y2: 184.29,
    gradientTransform: "translate(-7408.41 885.62) scale(88.65 -4.19)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3a3eef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#12b9d9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "privacy-policy_svg__d",
    x1: 84.57,
    y1: 177.81,
    x2: 85.62,
    y2: 184.29,
    gradientTransform: "translate(-7408.41 896.51) scale(88.65 -4.19)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3a3eef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#12b9d9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "privacy-policy_svg__e",
    x1: 84.57,
    y1: 177.81,
    x2: 85.62,
    y2: 184.29,
    gradientTransform: "translate(-7408.41 907.41) scale(88.65 -4.19)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3a3eef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#12b9d9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "privacy-policy_svg__f",
    x1: 69.82,
    y1: 174.02,
    x2: 70.87,
    y2: 180.49,
    gradientTransform: "translate(-264.7 1100.46) scale(5.47 -5.47)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3a3eef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#12b9d9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "privacy-policy_svg__g",
    x1: 84.79,
    y1: 168.18,
    x2: 85.49,
    y2: 168.94,
    gradientTransform: "translate(-5157.58 10888.19) scale(63.39 -63.39)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3a3eef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#12b9d9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "privacy-policy_svg__h",
    x1: 67.93,
    y1: 174.32,
    x2: 68.63,
    y2: 175.07,
    gradientTransform: "translate(-83.32 1861.54) scale(4.72 -9.45)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3a3eef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#12b9d9"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "m198.7,178.47l-149.48,41.22L0,41.22,149.48,0l49.22,178.47Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m198.7,178.47l-149.48,41.22L0,41.22,149.48,0l49.22,178.47Zm-147.57,37.86l144.2-39.77L147.57,3.36,3.36,43.12l47.77,173.21Z",
    style: {
      fill: "#f1f1f1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m116.95,79.95l-37.47,10.33c-1.1.3-2.24-.34-2.54-1.44l-10.33-37.47c-.3-1.1.34-2.24,1.44-2.54l37.47-10.33c1.1-.3,2.24.34,2.54,1.44l10.33,37.47c.3,1.1-.34,2.24-1.44,2.54Zm-48.68-30.32c-.66.18-1.05.87-.87,1.53l10.33,37.47c.18.66.87,1.05,1.53.87l37.47-10.33c.66-.18,1.05-.87.87-1.53l-10.33-37.47c-.18-.66-.87-1.05-1.53-.87l-37.47,10.33Z",
    style: {
      fill: "#e5e5e5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m107.45,87.5l-37.47,10.33c-.99.27-2.01-.31-2.29-1.3l-10.33-37.47c-.27-.99.31-2.01,1.3-2.29l37.47-10.33c.99-.27,2.01.31,2.29,1.3l10.33,37.47c.27.99-.31,2.01-1.3,2.29h0Z",
    style: {
      fill: "url(#privacy-policy_svg__b)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 44.9,
    y: 106.96,
    width: 108.46,
    height: 4.19,
    transform: "translate(-25.43 30.28) rotate(-15.42)",
    style: {
      fill: "#f1f1f1"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 47.8,
    y: 117.5,
    width: 108.46,
    height: 4.19,
    transform: "translate(-28.12 31.43) rotate(-15.42)",
    style: {
      fill: "#f1f1f1"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 50.71,
    y: 128.03,
    width: 108.46,
    height: 4.19,
    transform: "translate(-30.82 32.58) rotate(-15.42)",
    style: {
      fill: "#f1f1f1"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 55.82,
    y: 146.57,
    width: 108.46,
    height: 4.19,
    transform: "translate(-35.56 34.61) rotate(-15.42)",
    style: {
      fill: "#f1f1f1"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 58.73,
    y: 157.11,
    width: 108.46,
    height: 4.19,
    transform: "translate(-38.26 35.76) rotate(-15.42)",
    style: {
      fill: "#f1f1f1"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.63,
    y: 167.64,
    width: 108.46,
    height: 4.19,
    transform: "translate(-40.96 36.91) rotate(-15.42)",
    style: {
      fill: "#f1f1f1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m246.55,219.1H91.49V33.96h155.06v185.14Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m246.55,219.1H91.49V33.96h155.06v185.14Zm-152.32-2.73h149.59V36.7H94.23v179.67Z",
    style: {
      fill: "#e5e5e5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 129.66,
    y: 113.55,
    width: 88.65,
    height: 4.19,
    style: {
      fill: "url(#privacy-policy_svg__c)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 129.66,
    y: 124.45,
    width: 88.65,
    height: 4.19,
    style: {
      fill: "url(#privacy-policy_svg__d)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 129.66,
    y: 135.34,
    width: 88.65,
    height: 4.19,
    style: {
      fill: "url(#privacy-policy_svg__e)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 122.46,
    cy: 116.26,
    r: 2.73,
    style: {
      fill: "url(#privacy-policy_svg__f)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 129.66,
    y: 66.59,
    width: 88.65,
    height: 4.19,
    style: {
      fill: "#e5e5e5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 129.66,
    y: 77.49,
    width: 88.65,
    height: 4.19,
    style: {
      fill: "#e5e5e5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 129.66,
    y: 88.39,
    width: 88.65,
    height: 4.19,
    style: {
      fill: "#e5e5e5"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 122.46,
    cy: 68.84,
    r: 2.73,
    style: {
      fill: "#e5e5e5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 129.66,
    y: 160.96,
    width: 88.65,
    height: 4.19,
    style: {
      fill: "#e5e5e5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 129.66,
    y: 171.86,
    width: 88.65,
    height: 4.19,
    style: {
      fill: "#e5e5e5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 129.66,
    y: 182.76,
    width: 88.65,
    height: 4.19,
    style: {
      fill: "#e5e5e5"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 122.46,
    cy: 163.22,
    r: 2.73,
    style: {
      fill: "#e5e5e5"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 239.31,
    cy: 203.35,
    r: 31.69,
    style: {
      fill: "url(#privacy-policy_svg__g)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m248.09,201.33v-6.06c-.05-4.85-4.03-8.74-8.88-8.69-4.78.05-8.63,3.91-8.69,8.69v6.06c-2.44.11-4.36,2.12-4.36,4.56v14.33h26.28v-14.33c0-2.44-1.92-4.45-4.36-4.56Zm-8.78-11.75c3.14,0,5.68,2.55,5.69,5.69v6.05h-11.38v-6.05c0-3.14,2.55-5.68,5.69-5.69Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m241.67,208.41c0-1.3-1.06-2.36-2.36-2.36-1.3,0-2.36,1.06-2.36,2.36,0,.78.39,1.51,1.03,1.95v5.14h2.66v-5.14c.65-.44,1.03-1.17,1.03-1.95Z",
    style: {
      fill: "url(#privacy-policy_svg__h)"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrivacyPolicy);
export default __webpack_public_path__ + "static/media/privacy-policy.845a12dc83cc066e4ce499576b146734.svg";
export { ForwardRef as ReactComponent };